import React, { useContext } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import styled, { css } from 'styled-components';
import styles from './ContactMe.module.css';

import { SectionContainer } from './common/SectionContainer';
import Title from './common/Title';
import Subtitle from './common/Subtitle';
import Button from './common/Button';

import { DarkModeContext } from './context/DarkModeContext';
import { COLORS , SIZE} from './common/constants';

const ContactMe = () => {
	const { isDarkModeOn } = useContext(DarkModeContext);
	const inputStyle = {
		border: '0.5px solid rgba(116, 116, 116, 0.3)',
		borderRadius: '2px',
		backgroundColor: ' transparent',
		padding: '0.25rem 0.5rem',
		fontFamily: 'Montserrat',
		fontWeight: ' 300',
		lineHeight: '1.8',
		textDecoration: 'none',
		outline: ' none',
		color: isDarkModeOn ? `${COLORS.white}` : `${COLORS.grey}`
	};

	return (
		<SectionContainer id='contactMe'>
			<Title title='Contact Me' symbol='📬'></Title>
			<Subtitle subtitle="I'll look forward to hearing from you!"></Subtitle>
			<FormContainer>
				<Formik
					initialValues={initialValues}
					validationSchema={validationSchema}
					onSubmit={onSubmit}
				>
					<Form>
						<div className={styles.inputName}>
							<LabelStyled htmlFor='name' isDarkModeOn={isDarkModeOn}>
								Name
							</LabelStyled>
							<Field
								style={inputStyle}
								type='text'
								id='name'
								name='name'
								placeholder='Brie Larson'
							/>
							<ErrorMessage
								name='name'
								render={(message) => (
									<div className={styles.errorMessage}>{message}</div>
								)}
							/>
						</div>
						<div className={styles.inputEmail}>
							<LabelStyled htmlFor='email' isDarkModeOn={isDarkModeOn}>
								Email
							</LabelStyled>
							<Field
								style={inputStyle}
								type='text'
								id='email'
								name='email'
								placeholder='captain@marvel.com'
							/>
							<ErrorMessage
								name='email'
								render={(message) => (
									<div className={styles.errorMessage}>{message}</div>
								)}
							/>
						</div>
						<div className={styles.inputMessage}>
							<LabelStyled htmlFor='message' isDarkModeOn={isDarkModeOn}>
								Message
							</LabelStyled>
							<Field
								style={inputStyle}
								className={styles.messageBox}
								placeholder='Leave me a message'
								type='text'
								id='message'
								name='message'
							/>
							<ErrorMessage
								name='message'
								render={(message) => (
									<div
										className={styles.errorMessage}
										style={{ paddingTop: '0.75rem' }}
									>
										{message}
									</div>
								)}
							/>
						</div>
					</Form>
				</Formik>
			</FormContainer>
			<Button type='submit' props='Send'></Button>
		</SectionContainer>
	);
};

export default ContactMe;

const initialValues = {
	name: '',
	email: '',
	message: ''
};

const onSubmit = (values) => {
	console.log('Form data', values);
};

const validationSchema = Yup.object({
	name: Yup.string().required('Required'),
	email: Yup.string().email('Invalid email').required('Required'),
	message: Yup.string().required('Required')
});

// 🎨 Styled Components 
const FormContainer = styled.div`
	width: 100%;
	margin: 2rem 0;
`;

const LabelStyled = styled.label`
	font-size: 1rem;
	font-family: 'Montserrat', sans-serif;
	color: ${COLORS.mainBlue};
	font-weight: 500;
	margin-right: 1vw;
	${(props) =>
		props.isDarkModeOn &&
		css`
			color: ${COLORS.mainAqua};
		`}

	@media (max-width: ${SIZE.small}) {
		margin-right: 2.5vw;
	}
`;
